export default {
  ProgramBudget: 0,
  ProgramCurrencyCode: null,
  InvoiceCurrencyCode: null,
  OriginalInvoiceCurrencyCode: null,

  TotalInvoicedAmount: 0,
  TotalVatGstAmount: 0,

  CurrentInvoicedAmount: 0,
  CurrentVatGstAmount: 0,

  ExpenseAmount: 0,
  TotalVatGstOnExpense: 0,

  BudgetBalance: 0,

  InvoiceWasSubmitted: null,
  ExcludeVATFromBudget: null,

  ShowVatAllocation: null,
  ShowExpenses: null,
  IncludeExpenseInBudget: null,

  initDataForEdit: true,
  useHighLevelAllocation: null,

  InvoiceWorkflow: '',

  POCurrencyCode: null,

  TotalAmount: 0,
  TotalInvoiceAmount: 0,

  ReceivedAmount: 0,
  TotalUnprocessed: 0,
  POBalance: 0,

  ProgramIsSelected: false
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/models/budget-snapshot-model.js